import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Http, Headers } from "@angular/http";
import { HTTPService } from "../Services/http.service";
import { MySharedService } from "../App/shared.service";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { Constants } from "../Services/Constants";

@Component({
  templateUrl: "../AppViews/login.html",
  providers: [HTTPService],
})
export class LoginComponent implements OnInit {
  public userDetail: any = {};
  public userInfo: any = {};
  public showLoader = false;
  constant: Constants;
  public isFormSubmitted: boolean = false;
  menuItems: any;

  isCentralLogin = false;

  constructor(
    private _router: Router,
    private _httpService: HTTPService,
    private activatedRoute: ActivatedRoute,
    private _sharedService: MySharedService,
    private http: Http,
  ) {
    this.userDetail = { UserName: "", Password: "", RememberMe: true };
    this.constant = new Constants();
  }

  ngOnInit() {
    this.isCentralLogin = this._httpService.isCentralLogin;

    this.activatedRoute.queryParams.subscribe((params) => {
      var code = params["code"];

      if (code && this.isCentralLogin) {
        console.log("SSO Code:", code);

        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        let body = {
          code: code,
          clientId: "pms_client",
          clientSecret:
            "$2a$12$LQv3c1yqBWVHxkd0LHAkCOYz6TtxMQJqhN8/LewTa0NeE.JxBSc3S",
        };

        this.http
          .post(this._httpService.centralApiUrl + "/sso/validate-code", body, {
            headers: headers,
          })
          .map((res) => res.json())
          .subscribe(
            (result) => {
              console.log("SSO", result);
              this.goLogin_cdb(result.user.email);
            },
            (err) => {
              console.error("SSO Login Failed", err);
              // window.location.href = this._httpService.centralBaseUrl;
            },
          );
      } else {
        let centralLogin = false;
        const cookieValue = JSON.parse(Cookie.get("centralLogin")) || false;
        if (cookieValue && this.isCentralLogin) {
          centralLogin = cookieValue == true;
          if (centralLogin == true && typeof window !== "undefined") {
            window.location.href = this._httpService.centralBaseUrl;
          }
        }
      }
    });

    let userlogin: any = Cookie.get("userlogin");
    if (userlogin != null) {
      this.userDetail = JSON.parse(userlogin);
    } else {
      $("#txtusername").focus();
    }
  }

  public goLogin(form: any) {
    this.isFormSubmitted = true;
    if (form.form.valid) {
      localStorage.removeItem("menuItems");
      localStorage.removeItem("timesheetInfo");
      this.showLoader = true;
      if (this.isCentralLogin) {
        this.getUserByUsername(this.userDetail.UserName).subscribe(
          (userId) => {
            if (userId) {
              console.log("Central user found:", userId);
              Cookie.set("centralLogin", "true");
              window.location.href = this._httpService.centralBaseUrl;
            } else {
              this.normalLogin();
            }
          },
          (err) => {
            console.log("Central user not found");
            this.normalLogin();
          },
        );
      } else {
        this.normalLogin();
      }
    }
  }

  normalLogin() {
    this._httpService.ajaxPost("login/login", this.userDetail).subscribe(
      (data) => {
        if (data["Status"].IsSuccess) {
          if (data["UserDetail"].Is_Active) {
            localStorage.setItem(
              "userDetail",
              JSON.stringify(data["UserDetail"]),
            );

            var now = moment().valueOf().toString();
            localStorage.setItem("setupTime", now);

            this.userInfo = JSON.parse(localStorage.getItem("userDetail"));

            var Menu = data["Menu"];

            this._router.navigate([Menu.MenuURl]);
          } else {
            this._sharedService.ShowMessage(this.constant.userInactiveError);
          }
        } else {
          this._sharedService.ShowMessage("error|Wrong UserName or Password");
        }
      },
      (err) => {
        this.showLoader = false;
        this._sharedService.ShowMessage(this.constant.globalError);
      },
      () => {
        this.showLoader = false;

        if (this.userDetail.RememberMe) {
          Cookie.set("userlogin", JSON.stringify(this.userDetail));
        } else {
          Cookie.delete("userlogin");
        }
      },
    );
  }

  public goLogin_cdb(username) {
    if (username) {
      localStorage.removeItem("menuItems");
      localStorage.removeItem("timesheetInfo");
      this.showLoader = true;
      this._httpService
        .ajaxPost("login/logincdb", { UserName: username })
        .subscribe(
          (data) => {
            if (data["Status"].IsSuccess) {
              if (data["UserDetail"].Is_Active) {
                localStorage.setItem(
                  "userDetail",
                  JSON.stringify(data["UserDetail"]),
                );
                var now = moment().valueOf().toString();
                localStorage.setItem("setupTime", now);
                this.userInfo = JSON.parse(localStorage.getItem("userDetail"));
                var Menu = data["Menu"];

                Cookie.set("centralLogin", "true");

                this._router.navigate([Menu.MenuURl]);
              } else {
                this._sharedService.ShowMessage(
                  this.constant.userInactiveError,
                );
              }
            } else {
              this._sharedService.ShowMessage(
                "error|Wrong UserName or Password",
              );
              if (typeof window !== "undefined") {
                window.location.href = this._httpService.centralBaseUrl;
              }
            }
          },
          (err) => {
            this.showLoader = false;
            this._sharedService.ShowMessage(this.constant.globalError);
          },
          () => {
            this.showLoader = false;
            if (this.userDetail.RememberMe) {
              Cookie.set("userlogin", JSON.stringify(this.userDetail));
            } else {
              Cookie.delete("userlogin");
            }
          },
        );
    }
  }

  getUserByUsername(username: string) {
    console.log(
      `${this._httpService.centralApiUrl}/users/by-username/${username}`,
    );
    const headers = new Headers({
      "x-api-secret": "44dee6bd5cc6172e17775a4f0b7",
    });

    return this.http.get(
      `${this._httpService.centralApiUrl}/users/by-username/${username}`,
      { headers },
    );
  }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/App/login.component.ts
 **/